import useClientPagination from './useClientPagination';
import useTableSort from './useTableSort';

/**
 * Sort (default id asc) then paginate — use for client-side list/report tables.
 */
export default function useSortedClientPagination(items, options = {}) {
    const {
        columns,
        resetKey = null,
        defaultSortKey = 'id',
        defaultSortDir = 'asc',
    } = options;

    const sort = useTableSort(items, { columns, defaultSortKey, defaultSortDir, resetKey });
    const pagination = useClientPagination(
        sort.sortedItems,
        `${resetKey ?? ''}|${sort.sortKey}|${sort.sortDir}`
    );

    return { ...sort, ...pagination };
}
